import React from 'react'
import image3 from "../img/earth-216834_1280_0.jpg"

const Slide3 = () => {
    return (
        <div className="">
            <div className="container container3">
                <div class="head"></div>
                <div className="text">
                    Nun brennt an vielen Stellen die Erde. Diese Wahlen sind vielleicht die letzte Chance,
                    unseren Kindern und Enkeln eine Welt zu ermöglichen,
                    die ihnen Lebensperspektiven schenkt; ein Dasein in Sicherheit,
                    Menschlichkeit und Gesundheit. 
                    <span>In dieser sozialen Verantwortung wenden wir uns an Sie.</span>
                </div>
                <div className="image image3">
                    <img src={image3} alt=""></img>
                </div>
                <div class="Footer"></div>
            </div>
        </div>
    )
}

export default Slide3;